import { jsx as _jsx } from "react/jsx-runtime";
import { TrackableIconBox, TrackableSvgIcon } from './TrackableStatusIcon.styled';
import yellowTrackableIcon from '@/core/svg/chz-Checkmark-yellow.svg';
/**
 * Should be used inside GoodsWorkflowTable.
 *
 * @param status
 */
const TrackableStatusIcon = ({ status }) => {
    // isNullish or TrackableStatus.None
    if (!status)
        return null;
    return (_jsx(TrackableIconBox, { children: _jsx(TrackableSvgIcon, { size: "xl", icon: yellowTrackableIcon, status: status }) }));
};
export { TrackableStatusIcon };
